<script lang="ts">
  import dwcLogo from '../../assets/dwc.png';
</script>

<div class="LayoutLogo">
  <figure>
    <picture>
      <img alt="DWC-Tools Logo" src={dwcLogo} />
    </picture>
  </figure>
</div>

<style lang="scss">
  .LayoutLogo {
    picture {
      max-width: 15rem;
      margin: 0 auto;
    }
  }
</style>
